import { render, staticRenderFns } from "./active-person-add.vue?vue&type=template&id=44929a1f&scoped=true&"
import script from "./active-person-add.vue?vue&type=script&lang=js&"
export * from "./active-person-add.vue?vue&type=script&lang=js&"
import style0 from "./active-person-add.vue?vue&type=style&index=0&id=44929a1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44929a1f",
  null
  
)

export default component.exports